export enum AlertEnum {
  PriceChangeAlert = 'PriceChangeAlert',
  TimeChangeAlert = 'TimeChangeAlert',
  AirportChangeAlert = 'AirportChangeAlert',
  StandAloneOptionNotFoundUsingDefault = 'StandAloneOptionNotFoundUsingDefault',
  FlightNotFound = 'FlightNotFound',
  HotelNotFound = 'HotelNotFound',
  CarNotFound = 'CarNotFound',
  ProductsNotFound = 'ProductsNotFound',
  SelectedHotelNotAvailable = 'SelectedHotelNotAvailable',
  FlightChangeAlert = 'FlightChangeAlert',
  HotelNameNotFound = 'HotelNameNotFound',
  InvalidFrequentFlyer = 'InvalidFrequentFlyer',
  InValidBlueBizNumber = 'InValidBlueBizNumber',
  FlightNameNotFound = 'FlightNameNotFound',
  HotelRoomChangeAlert = 'HotelRoomChangeAlert',
  HotelChangeAlert = 'HotelChangeAlert',
  HotelCategoryTagNotFound = 'HotelCategoryTagNotFound',
  FlightNumberChange = 'FlightNumberChange',
  ActivityDatesNotFound = 'ActivityDatesNotFound',
  AirlineChangeAlert = 'AirlineChangeAlert',
  BookingClassChangeAlert = 'BookingClassChangeAlert',
  CabinClassChangeAlert = 'CabinClassChangeAlert',
  PassengerNameChangeAlert = 'PassengerNameChangeAlert',
  NumberOfSegmentsChangeAlert = 'NumberOfSegmentsChangeAlert',
  SelectedPickupHotelNotAvailable = 'SelectedPickupHotelNotAvailable',
  PassengerDobChangeAlert = 'PassengerDobChangeAlert',
  DepartureDateTimeChangeAlert = 'DepartureDateTimeChangeAlert',
  ArrivalDateTimeChangeAlert = 'ArrivalDateTimeChangeAlert',
  DepartureAirportChangeAlert = 'DepartureAirportChangeAlert',
  ArrivalAirportChangeAlert = 'ArrivalAirportChangeAlert',
  BaggageAllowanceChangeAlert = 'BaggageAllowanceChangeAlert',
}

export type AlertEnumType = keyof typeof AlertEnum;
